// src/Cookies.js
import { motion } from 'framer-motion';
import { SITE_CONFIG } from './config';
import { useTheme } from './App';

function Cookies() {
  const { theme } = useTheme();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      className={`min-h-screen bg-gradient-to-br ${theme.primary.bg} ${theme.primary.text} p-6`}
    >
      <div className="max-w-4xl mx-auto">
        <motion.header
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-8"
        >
          <h1 className={`text-5xl font-extrabold bg-gradient-to-r ${theme.primary.accent} bg-clip-text text-transparent drop-shadow-2xl mb-4`}>
            Cookie Policy
          </h1>
        </motion.header>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className={`${theme.primary.card} p-8 rounded-2xl border shadow-2xl`}
        >
          <p className={`mb-6 leading-relaxed ${theme.primary.textSecondary}`}>
            This Cookie Policy explains how {SITE_CONFIG.brandName} ("we," "us," or "our") uses cookies and similar technologies on our website,{' '}
            <a href={`https://${SITE_CONFIG.domain}`} className={`bg-gradient-to-r ${theme.primary.accent} bg-clip-text text-transparent hover:underline`}>
              https://{SITE_CONFIG.domain}
            </a>{' '}
            (collectively, "the Site"). By using our Site, you consent to the use of cookies as described in this policy. You can adjust your preferences via our cookie banner or browser settings.
          </p>

          <h2 className={`text-2xl font-semibold mb-4 bg-gradient-to-r ${theme.primary.accent} bg-clip-text text-transparent mt-8`}>What Are Cookies?</h2>
          <p className={`mb-6 leading-relaxed ${theme.primary.textSecondary}`}>
            Cookies are small text files stored on your device (e.g., computer, tablet, or smartphone) when you visit our Site. They help us improve your experience, analyze usage, and support our services, including affiliate programs. Cookies can be "persistent" (lasting until a set expiration date) or "session" (deleted when you close your browser).
          </p>

          <h2 className={`text-2xl font-semibold mb-4 bg-gradient-to-r ${theme.primary.accent} bg-clip-text text-transparent mt-8`}>How We Use Cookies</h2>
          <p className={`mb-4 leading-relaxed ${theme.primary.textSecondary}`}>
            We use cookies for the following purposes:
          </p>
          <ul className={`list-disc ml-6 mb-6 space-y-3 ${theme.primary.textSecondary}`}>
            <li>
              <strong>Essential Cookies:</strong> These are necessary for the Site to function properly, such as enabling navigation, ensuring secure logins, and maintaining user session data. You cannot opt out of these cookies as they are required for basic functionality.
            </li>
            <li>
              <strong>Analytics Cookies:</strong> We use these to track and analyze how users interact with our Site (e.g., page views, time spent, referral sources) using tools like Google Analytics. This helps us improve user experience and optimize our content.
            </li>
            <li>
              <strong>Affiliate Cookies:</strong> We participate in affiliate programs, including the Amazon Associates Program, which uses cookies to track referrals and commissions from qualifying purchases you make through our links. As an Amazon Associate, we earn from qualifying purchases, and these cookies help us attribute those purchases to our Site.
            </li>
          </ul>

          <h2 className={`text-2xl font-semibold mb-4 bg-gradient-to-r ${theme.primary.accent} bg-clip-text text-transparent mt-8`}>Contact Us</h2>
          <p className={`mb-4 leading-relaxed ${theme.primary.textSecondary}`}>
            If you have questions, concerns, or requests regarding this Cookie Policy, please contact us:
          </p>
          <ul className={`list-disc ml-6 mb-6 ${theme.primary.textSecondary}`}>
            <li>Email: <a href={`mailto:${SITE_CONFIG.contact.privacyEmail}`} className={`bg-gradient-to-r ${theme.primary.accent} bg-clip-text text-transparent hover:underline`}>{SITE_CONFIG.contact.privacyEmail}</a></li>
          </ul>

          <p className={`mt-8 text-sm ${theme.primary.textMuted}`}>
            Last updated: August 17, 2025
          </p>
        </motion.div>
      </div>
    </motion.div>
  );
}

export default Cookies;
